import { inject, injectable } from 'tsyringe';
import { type IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { type IBuyerUserRepository } from 'application/repositorySchemas/IBuyerUserRepository';

// UseCase
export interface IBuyerUserLogout {
    readonly buyerUserToken: IBuyerUserTokenRepository;
    readonly buyerUser: IBuyerUserRepository;
    execute(): Promise<void>;
}

// Interactor
@injectable()
export class BuyerUserLogout implements IBuyerUserLogout {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerUserRepository')
        public readonly buyerUser: IBuyerUserRepository,
    ) {}

    public async execute() {
        const token = this.buyerUserToken.get();
        if (token === null) {
            return;
        }
        await this.buyerUser.logout();
        this.buyerUserToken.remove();
    }
}
